import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Menu, Avatar, Icon, Tooltip } from 'antd';
import { userAvatarSelector, personNameSelector } from '../../scenes/User/UserSelectors';
import '../../../../components/Sider/Sider.scss';
import './Sider.scss';

const { SubMenu } = Menu;

const Sider = ({
  menuItems,
  selectedKey,
  basePath = '/admin',
  defaultOpenKeys,
  userAvatar,
  personName,
  onLogout,
  navigationSiderCollapsed = false,
}) => (
  <div className="sider-admin-layout">
    <div className="sider-admin-scroll">
      {/* User header */}
      <div
        className={classNames('sider-admin-user-header', {
          'sider-admin-user-header--collapsed': navigationSiderCollapsed,
        })}
      >
        <Avatar
          size={navigationSiderCollapsed ? 32 : 36}
          icon="user"
          src={userAvatar}
          className="sider-admin-user-avatar"
        />
        {!navigationSiderCollapsed && (
          <div className="sider-admin-user-info">
            <div className="sider-admin-user-name">{personName || 'Admin'}</div>
            <div className="sider-admin-user-role">Administration</div>
          </div>
        )}
      </div>

      <nav aria-label="Admin navigation">
        <Menu
          mode="inline"
          inlineIndent={8}
          selectedKeys={[selectedKey]}
          defaultOpenKeys={defaultOpenKeys}
          className="sider-menu sider-menu-admin-main"
        >
          {menuItems.map((item) => {
            if (item.type === 'sub-menu') {
              return (
                <SubMenu
                  key={item.name}
                  title={
                    <span>
                      <Icon type={item.icon} aria-hidden />
                      <span>{item.name}</span>
                    </span>
                  }
                >
                  {item.submenus.map((subitem) => (
                    <Menu.Item key={subitem.route} title={subitem.name}>
                      <Link to={`${basePath}/${subitem.route}`}>{subitem.name}</Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            }
            return (
              <Menu.Item key={item.route} title={item.name}>
                <Link to={`${basePath}/${item.route}`}>
                  <Icon type={item.icon} aria-hidden />
                  <span>{item.name}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </nav>
    </div>

    <div className="sider-admin-footer">
      {navigationSiderCollapsed ? (
        <>
          <Tooltip title="Contact Us" placement="right">
            <Link
              to="/contact-us"
              className="sider-footer-item sider-footer-item--icon-only"
              aria-label="Contact Us"
            >
              <Icon type="form" aria-hidden />
            </Link>
          </Tooltip>
          <Tooltip title="Log out" placement="right">
            <button
              type="button"
              className="sider-footer-item sider-footer-item-logout sider-footer-item--icon-only"
              onClick={onLogout}
              aria-label="Log out"
            >
              <Icon type="logout" aria-hidden />
            </button>
          </Tooltip>
        </>
      ) : (
        <>
          <Link to="/contact-us" className="sider-footer-item">
            <Icon type="form" aria-hidden />
            <span>Contact Us</span>
          </Link>
          <button
            type="button"
            className="sider-footer-item sider-footer-item-logout"
            onClick={onLogout}
            aria-label="Log out"
          >
            <Icon type="logout" aria-hidden />
            <span>Log out</span>
          </button>
        </>
      )}
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  userAvatar: userAvatarSelector(state),
  personName: personNameSelector(state),
});

export default connect(mapStateToProps)(Sider);
